import{z as e}from"zod";const t=e.object({eventName:e.string().min(1)}).strict();export{t as createWebhookSubscriptionDto};
//# sourceMappingURL=create-webhook-subscription.dto.mjs.map